import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as DropdownDownArrow } from '../../assets/icons/dropdownArrowDown.svg';
import { ReactComponent as DropdownUpArrow } from '../../assets/icons/dropdownArrowUp.svg';
import Button from '../button/Button';
import './vehicleSelector.css';

export const VehicleSelector = ({ label, options, setCustomBooking, vehicleCounts, setVehicleCounts }) => {
    const [isOpen, setIsOpen] = useState(false);
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutsidePopup = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsidePopup);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsidePopup);
        };
    }, []);

    useEffect(() => {
        if (options?.length) {
            const initialCounts = options.map((v) => ({
                vehicleName: v,
                vehicleCount: 0
            }));
            setVehicleCounts(initialCounts);
        }
    }, [options]);

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    const handleIncrement = (vehicleName) => {
        setVehicleCounts((prev) =>
            prev.map((vehicleItem) =>
                vehicleItem.vehicleName === vehicleName
                    ? { ...vehicleItem, vehicleCount: vehicleItem.vehicleCount + 1 }
                    : vehicleItem
            )
        );
    };

    const handleDecrement = (vehicleName) => {
        setVehicleCounts((prev) =>
            prev.map((vehicleItem) =>
                vehicleItem.vehicleName === vehicleName
                    ? { ...vehicleItem, vehicleCount: Math.max(vehicleItem.vehicleCount - 1, 0) }
                    : vehicleItem
            )
        );
    };

    useEffect(() => {
        if (vehicleCounts?.length) {
            setCustomBooking((prev) => ({
                ...prev,
                customTrip: {
                    ...prev.customTrip,
                    vehicleType: vehicleCounts
                }
            }));
        }
    }, [vehicleCounts]);

    return (
        <div>
            <div ref={popupRef} className='vehicleSelector-container'>
                <div className='vehicleSelector-container-div' onClick={handleToggle}>
                    <div className='vehicleSelector-label-container'>
                        <label className='vehicleSelector-label'>{label}</label>
                    </div>
                    <div className='dropdown-arrow-icon'>{isOpen ? <DropdownUpArrow /> : <DropdownDownArrow />}</div>
                </div>
                {isOpen && (
                    <div className='vehicle-popup-container'>
                        <div className='vehicle-popup-content'>
                            <p className='vehicle-popup-content-header-text'>Select Vehicle</p>
                            {options.map((vehicleItem, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={`${index !== options.length - 1 ? 'vehicle-item' : 'vehicle-item-last-child'}`}
                                    >
                                        <span style={{ marginLeft: 10 }}>{vehicleItem}</span>
                                        <div className='vehicle-counter-card'>
                                            <div
                                                onClick={() => handleDecrement(vehicleItem)}
                                                style={{ fontSize: 25 }}
                                                className='vehicle-decrement-btn'
                                            >
                                                -
                                            </div>
                                            <span style={{ fontSize: 18, marginTop: 5 }} className='counter-text-value'>
                                                {vehicleCounts.find((v) => v.vehicleName === vehicleItem)
                                                    ?.vehicleCount ?? 0}
                                            </span>
                                            <div
                                                onClick={() => handleIncrement(vehicleItem)}
                                                style={{ fontSize: 25 }}
                                                className='increment-btn'
                                            >
                                                +
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <Button onClick={() => setIsOpen(false)} className='close-btn-vehicle'>
                                Close
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
